export const Logo = ({ compact = false, onClick }) => {
  return (
    <button type="button" onClick={onClick} data-testid="nav-logo" className="inline-flex items-center hover:opacity-90 transition-opacity">
      <img src="/logo-knockout.png" alt="Talanta Hela — monetizing talents" className={compact ? "h-11 w-auto" : "h-14 w-auto"} />
    </button>
  );
};
